// extracted by mini-css-extract-plugin
export default {"bonus-item":"bonus-item_bonus-item__JVt1E","bonus-item-button":"bonus-item_bonus-item-button__Vl1v4","countdown-item":"bonus-item_countdown-item__0LRQH"};